import users from '@/router/users'
import products from '@/router/products'
import commands from '@/router/commands'
import trainings from '@/router/trainings'
import management from '@/router/management'
import messages from '@/router/messages'
import requests from '@/router/requests'
import points from '@/router/points'
import logs from '@/router/logs'
import apps from '@/router/apps'

const main = [
  {
    path: '/dashboard',
    name: 'dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    components: {
      content: () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue')
    },
    meta: {
      moduleSlug: 'dashboard'
    }
  },
  // {
  //   path: '/dashboard-matrix',
  //   name: 'dashboard',
  //   redirect: '/dashboard',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   components: {
  //     content: () => import(/* webpackChunkName: "dashboard" */ '@/views/DashboardMatrix.vue')
  //   },
  //   meta: {
  //     allowedTenant: ['fullVersion', 'liteVersion']
  //   }
  // },
  {
    path: '/users-roles',
    name: 'users-roles',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      isParent: true,
      moduleSlug: 'users'
    },
    children: [...users],
    redirect: '/users-roles/roles'
  },
  {
    path: '/products-categories',
    name: 'products-categories',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      isParent: true,
      moduleSlug: 'products'
    },
    children: [...products],
    redirect: '/products-categories/categories'
  },
  {
    path: '/commands',
    name: 'commands',
    meta: {
      requiredRole: ['admin'],
      isParent: true,
      moduleSlug: 'command-ipc'
    },
    children: [...commands],
    redirect: '/commands/ipc'
  },
  {
    path: '/trainings-schulungen',
    name: 'trainings-schulungen',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      isParent: true,
      moduleSlug: 'trainings'
    },
    children: [...trainings],
    redirect: '/trainings-schulungen/trainings'
  },
  {
    path: '/management',
    name: 'management',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      isParent: true,
      moduleSlug: 'text-pages'
    },
    children: [...management],
    redirect: '/management/textpages'
  },
  {
    path: '/settings',
    name: 'settings',
    meta: {
      isParent: true,
      requiredRole: ['admin'],
      moduleSlug: 'messages'
    },
    children: [...messages],
    redirect: '/settings/messages'
  },
  {
    path: '/requests',
    name: 'requests',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'product-trainings-request',
      isParent: true
    },
    children: [...requests],
    redirect: '/requests/product-trainings-request'
  },
  {
    path: '/points',
    name: 'points',
    meta: {
      requiredRole: ['admin', 'middleAdmin'],
      moduleSlug: 'points-management',
      isParent: true
    },
    children: [...points],
    redirect: '/points/cheques'
  },
  {
    path: '/apps',
    name: 'apps',
    meta: {
      requiredRole: ['admin', 'middleAdmin'],
      isParent: true,
      moduleSlug: 'apps'
    },
    children: [...apps]
  },
  {
    path: '/logs',
    name: 'logs',
    meta: {
      requiredRole: ['admin', 'middleAdmin'],
      isParent: true,
      moduleSlug: 'activities'
    },
    children: [...logs],
    redirect: '/logs/activities'
  }
]

export default main
